import $ from 'jquery';

$('body').on('click', '.content-tabs-nav__item', function () {
    const $this = $(this);
    const index = $this.index();
    const tabsBlock = $this.closest('.content-tabs');
    tabsBlock.find('.content-tabs-nav__item').removeClass('content-tabs-nav__item--active');
    $(this).addClass('content-tabs-nav__item--active');
    tabsBlock.find('.content-tabs-block').removeClass('content-tabs-block--active');
    tabsBlock.find(`.content-tabs-block:eq(${index})`).addClass('content-tabs-block--active');
});
